<template>
  <div class="row no-margin">

    <div class="col p-0">
      <vs-tooltip
        :text="$t('apps.pos.message.printorders')"
        position="top">
        <button
          :class="[disabledClass]"
          class="btn btn-custom col no-margin action-btn"
          @click="onclickPrint()">
          <i class="fas fa-print"/>
        </button>
      </vs-tooltip>
    </div>

    <div class="col p-0">
      <vs-tooltip
        :text="$t('apps.pos.message.clearorders')"
        position="top">
        <button
          :class="[disabledClass]"
          class="btn btn-custom col no-margin action-btn"
          @click="onClickClearOrders()">
          <i
            class="far fa-trash-alt"
            style="font-weight: bold;"/>
        </button>
      </vs-tooltip>
    </div>

    <print-orders
      :orders="orders"
      :total_price="totalPrice"
      :created_at="moment().format('D/M/Y H:mm')"
      :font_size="getShopInfo.settings.apps.pos.receipt.font_size"
      class="receipt-template"
      style="position: fixed;z-index: -1;top: 1mm;left: 1mm;font-family: tahoma;color: black;width: 100%;"
    />

    <baseConfirmDeleteModal
      :show="modal.show"
      :loading="modal.loading"
      @onClose="handleCloseModal"
      @onCancel="handleCancleModal"
      @onSubmit="handleSumitModal"
    />

  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import _ from 'lodash'

import PrintOrders from '@/components/custom/print/pos/Orders.vue'
import { isMenuOnlineOrder } from '../../../../../../lib/v-calendar/utils/helpers'

export default {
  components: {
    PrintOrders,
  },
  data () {
    return {
      orders: [],
      bindClass: {
        disabled: '',
      },
      totalPrice: {},
      modal: {
        show: false,
        loading: false,
      },
    }
  },
  computed: {
    ...mapGetters({
      pos: 'getPos',
      queue_number: 'getPosSelectedQueueNumber',
      table_number: 'getPosSelectedTableNumber', // selected table_number
      getTableById: 'getPosTableById', // table info
      getPosOrdersById: 'getPosOrdersById', // get orders from table number
      getPosTotalPriceById: 'getPosTotalPriceById', // get total price from table number
      getShopInfo: 'getShopInfo',
      receiptInfo: 'getReceiptInfo',
    }),
    isDisabled() {
      return this.orders.length === 0
    },
    disabledClass () {
      return this.isDisabled ? 'disabled' : ''
    },
  },
  methods: {
    ...mapActions([
      'showingConfirmClearPosOrdesrModal',
      'clearPosOrderBy',
      'updateOrder',
    ]),
    onClickClearOrders () {
      if (this.isDisabled) {
        return
      }
      this.showingConfirmClearPosOrdesrModal(true)
      this.onOpenModal()
    },
    onclickPrint () {
      if (this.isDisabled) {
        return
      }
      // eslint-disable-next-line no-undef
      $('.receipt-template').printThis()
    },
    updateData () {
      this.orders = this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
        isDeleteQueue: false,
      })
      this.totalPrice = _.cloneDeep(this.getPosTotalPriceById({
        queue_number: this.queue_number,
        table_number: this.table_number,
      }, this.mixin))
    },
    onOpenModal () {
      this.modal.show = true
    },
    handleCloseModal () {
      this.showingConfirmClearPosOrdesrModal(false)
      this.modal.show = false
    },
    handleCancleModal () {
      this.showingConfirmClearPosOrdesrModal(false)
      this.modal.show = false
    },
    async handleSumitModal () {
      this.showingConfirmClearPosOrdesrModal(false)

      /**
       * update order status to firbase
       */
      const orders = this.getPosOrdersById({
        queue_number: this.queue_number,
        table_number: this.table_number,
        isDeleteQueue: false,
      })
      for (const order of orders) {
        if (isMenuOnlineOrder(order)) {
          this.updateOrder({
            queueNumber: `${order.queue_number}`,
            orderId: order.order_id,
            payload: {
              status: 'deleted',
            },
          })
        }
      }

      this.clearPosOrderBy({
        queue_number: this.queue_number,
        table_number: this.table_number,
      })
      this.modal.show = false
      this.$emit('onClearOrder')
    },
  },
  watch: {
    'pos.orders': {
      handler: function () {
        this.updateData()
      },
      deep: true,
    },
    'pos': {
      handler: function (after, before) {
        this.updateData()
      },
      deep: true,
    },
  },
  created: function () {
    this.updateData()
  },
  mounted: function () {

  },
}
</script>

<style scoped>
  button.action-btn.btn-custom {
    border: none;
    border-top: solid 1px #F2F2F2;
    background: #FFF;
    color: #6C7A86;
    font-size: 14px;
    font-weight: bold;
    padding: 14px 0 12px 0;
    outline: none;
    cursor: pointer;
    border-radius: 0;
  }
  button.action-btn.btn-custom:last-of-type {
    border-left: solid 1px #F2F2F2;
  }
  button.action-btn.btn-custom:focus {
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/apps/pos/sale/main/common/OptionsButton.vue